/**
 * Lightweight class-name combinator (replacement for `clsx` + `tailwind-merge`).
 * Keeps Friday dependency-light; if you ever need to merge tailwind classes
 * safely, swap this for `cn` from `clsx` + `tailwind-merge`.
 */
export function cn(...parts: Array<string | number | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
